// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608100525/js/" + chunkId + "." + {"44":"37944c80","225":"6b451ab7","481":"7a88f564","486":"9e8636da","770":"71c11872"}[chunkId] + ".0.385295921493784.chunk.js";
};